<template>
  <!-- <div class="text-secondary mb-3 note">
        Входя в личный кабинет пользователя, я подтверждаю, что даю <RouterLink to="/terms_of_use" target="_blank">согласие на обработку персональных
            данных</RouterLink>, сведений об абоненте и на получение кредитного отчета
    </div> -->
  <div class="text-secondary mb-3 note" style="text-align: justify">
    Осуществляя вход, вы подтверждаете, что ознакомлены и согласны с Политикой
    обработки персональных данных и предоставляете
    <a href="https://www.stone-xxi.ru/sogl-privacy/" class="" target="_blank"
      >согласие на обработку персональных данных</a
    >
  </div>
</template>